export const subscriptionTypeConstants = {
  flyjetsPlus: {
    code: 'FLYJETS_PLUS',
  },
  flyjetsCalendar: {
    code: 'FLYJETS_CALENDAR',
  },
}
